<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="分配供应商"
    :visible.sync="dialogVisible"
    width="888px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable
        ref="baseTable"
        :height="380"
        :tableData="tableData"
        :isPager="false"
        :selectRows="selectRows"
        :border="true"
        @handleSelectionChange="handleSelectionChange"
      >
        <el-input
          slot="phoneNumber"
          v-model="row.scope.phoneNumber"
          slot-scope="row"
          placeholder="请输入"
          @input="handleInputChange(row,'phoneNumber')"
        ></el-input>
        <el-input
          slot="email"
          v-model="row.scope.email"
          slot-scope="row"
          placeholder="请输入"
        ></el-input>
        <el-input
          slot="emailPassword"
          v-model="row.scope.emailPassword"
          slot-scope="row"
          placeholder="请输入"
        ></el-input>
        <el-input
          slot="remark"
          v-model="row.scope.remark"
          slot-scope="row"
          placeholder="请输入"
        ></el-input>
      </BaseTable>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        确定
      </div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable.vue')
import { getSupplierPageList, getImporterSupplierOrCompanyList, assignSupplier } from '@/api/system'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: Boolean,
    rowData: Object
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'supplierName',
            label: '供应商',
            width: 100
          },
          {
            filed: 'phoneNumber',
            label: '电话',
            width: 170,
            isCustom: true
          },
          {
            filed: 'email',
            label: '邮箱',
            width: 170,
            isCustom: true
          },
          {
            filed: 'emailPassword',
            label: '邮箱密码',
            width: 160,
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: 160,
            isCustom: true
          }
        ],
        columns: [],
        mutiCheck: true,
        mutiFixed: 'left'
      },
      selectionItem: [],
      selectRows: [],
      // 添加一个映射表来跟踪每行的选中状态
      rowSelectionMap: new Map()
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.getList()
        // 初始化映射表
        this.rowSelectionMap = new Map()
      }
    }
  },
  methods: {
    async getList() {
      try {
        // 1. 参数命名更语义化
        const allocationParams = {
          importerId: this.rowData.id,
          importerAllocationType: 2
        }
        const supplierParams = {
          pageIndex: 1,
          pageSize: 999,
          queryParam: {}
        }

        // 2. 并行请求使用命名清晰的变量
        const [supplierListRes, allocationListRes] = await Promise.all([
          getSupplierPageList(supplierParams),
          getImporterSupplierOrCompanyList(allocationParams)
        ])

        // 3. 增加对第二个请求结果的校验
        if (!supplierListRes.success) {
          this.$message.error(supplierListRes.errorMessage)
          return
        }
        if (!allocationListRes.success) {
          this.$message.error(allocationListRes.errorMessage)
          return
        }

        // 4. 使用Map优化查找性能（O(1)复杂度）
        const allocationMap = new Map()
        allocationListRes.data.forEach(item => {
          allocationMap.set(item.supplierId, item)
        })
        console.log('supplierListRes', supplierListRes)
        // 5. 简化数据处理逻辑
        this.tableData.columns = supplierListRes.data.list.map(supplier => {
          const allocation = allocationMap.get(supplier.id) || {}
          return {
            supplierId: supplier.id,
            supplierName: supplier.code,
            phoneNumber: allocation.supplierPhone || '',
            email: allocation.supplierEmail || '',
            emailPassword: allocation.supplierEmailPassword || '',
            remark: allocation.remark || ''
          }
        })

        // 6. 优化过滤逻辑（直接使用Map存在性判断）
        this.selectRows = this.tableData.columns.filter(col =>
          allocationMap.has(col.supplierId)
        )
        // 初始化选中状态映射表
        this.tableData.columns.forEach((row, index) => {
          this.rowSelectionMap.set(index, this.selectRows.includes(row))
        })
        this.$nextTick(() => {
          const elTable = this.$refs.baseTable?.$refs?.multipleTable;
          if (!elTable) return;

          // 勾选所有已分配的行
          this.selectRows.forEach(row => {
            elTable.toggleRowSelection(row, true);
          });
        })
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async ok() {
      // if (!this.selectionItem.length) {
      //   this.$message.error('请选择供应商进行分配')
      //   return
      // }
      this.loading = true
      try {
        const params = {
          importerId: this.rowData.id,
          supplier: this.selectionItem ?? []
        }
        const res = await assignSupplier(params)
        this.loading = false
        if (res.success) {
          this.$message.success(res.errorMessage)
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    handleSelectionChange(items) {
      this.selectionItem = items
      // 更新映射表中的选中状态
      this.tableData.columns.forEach((row, index) => {
        this.rowSelectionMap.set(index, items.includes(row))
      })
    },
    // 处理输入框变化事件
    handleInputChange(row, field) {
      // 检查是否有任何字段不为空
      const hasValue = row.scope.phoneNumber ||
                      row.scope.email ||
                      row.scope.emailPassword ||
                      row.scope.remark

      // 找到当前行在表格数据中的索引
      const rowIndex = this.tableData.columns.findIndex(
        item => item.supplierId === row.scope.supplierId
      )

      if (rowIndex !== -1) {
        // 获取 BaseTable 内部的 el-table 引用
        const elTable = this.$refs.baseTable.$refs.multipleTable
        if (hasValue && !this.rowSelectionMap.get(rowIndex)) {
          // 如果有值且当前行未被选中，则选中它
          elTable.toggleRowSelection(this.tableData.columns[rowIndex], true)
        } else if (!hasValue && this.rowSelectionMap.get(rowIndex)) {
          // 如果所有字段都为空且当前行被选中，则取消选中
          elTable.toggleRowSelection(this.tableData.columns[rowIndex], false)
        }
      }
  }
}
}
</script>

<style lang="less" scoped>
.content {
  /deep/ .el-table__row {
    td {
      padding: 0 !important;
    }
  }
  /deep/ .el-input {
    input {
      border: 0;
    }
  }
}
.footers {
  width: 100%;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }
  .ok {
    background: #142e79;
    color: #ffffff;
  }
}
</style>
